{
    "AllTelServer": "[Tutti i server di telefonia]",
    "AnyPartition": "[Qualsiasi partizione]",
    "AnyDevices": "[Qualsiasi dispositivo]",
    "AnyAgents": "[Qualsiasi agente ACD]",
    "AnyAgentForDevice": "[Qualsiasi dispositivo impostato]",
    "AnyDeviceForAgent": "[Qualsiasi con agente ACD impostato]",
    "DeviceValidation": "Un amministratore non può avere un livello di autorizzazione del dispositivo impostato",
    "AgentValidation": "Un amministratore non può avere un livello di autorizzazione per gli agenti impostato",
    "PermissionsLanguage_PermissionsNote": "Impostare le autorizzazioni del livello di accesso dell'utente.",
    "PermissionsLanguage_CmEnvironment": "ECM:",
    "PermissionsLanguage_TelServer": "Server di telefonia:",
    "PermissionsLanguage_Partition": "Partizione:",
    "PermissionsLanguage_Device": "Gruppo\/dispositivo:",
    "PermissionsLanguage_AndOrAgent": "Agente:",
    "NAME": "PermissionsLanguage",
    "EssentialsDeviceValidation": "Questo tipo di utente deve avere un dispositivo di autorizzazione impostato",
    "EssentialsDeviceValidation_MST": "Un utente CXA Standard deve avere un dispositivo di autorizzazione impostato",
    "PermissionsLanguage_SynchroniseSupervisorPermissions": "Sincronizzazione delle autorizzazioni del supervisore dalla piattaforma di telefonia"
}